/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupssend1Inputs */

const en_groupssend1 = /** @type {(inputs: Groupssend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const de_groupssend1 = /** @type {(inputs: Groupssend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Groupssend1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupssend1 = /** @type {((inputs?: Groupssend1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupssend1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupssend1(inputs)
	return de_groupssend1(inputs)
});
export { groupssend1 as "groupsSend" }